import FilterNoneIcon from '@mui/icons-material/FilterNone';
import { Theme, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import copy from 'copy-to-clipboard';
import React, { useMemo } from 'react';

const styles = (theme: Theme) => ({
  button: {
    '&.MuiIconButton-root': {
      ...theme.typography.caption,
      '& :hover': {
        background: 'none',
        fill: theme.palette.primary.main,
      },
      fill: theme.palette.grey[500],
      fontSize: '1rem',
      marginLeft: theme.spacing(0.5),
    },
  },
  description: {
    ...theme.typography.caption,
    color: theme.palette.secondary.main,
    fontSize: '1rem',
    marginLeft: theme.spacing(1),
  },
  iconSmall: {
    '&.MuiSvgIcon-root': {
      ...theme.typography.caption,
      fontSize: '1rem',
    },
  },
  label: {
    ...theme.typography.caption,
    color: theme.palette.common.black,
    fontSize: '1rem',
  },
});

export interface IClipboardLabelProps {
  description?: string | React.ReactNode;
  label: string | React.ReactNode;
  value?: string | React.ReactNode;
}

export function ClipboardLabel({ description = null, label, value = null }: IClipboardLabelProps) {
  const theme = useTheme();
  const stylesObj = useMemo(() => styles(theme), [theme]);

  const clickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const textToCopy = typeof value === 'string' ? value : typeof label === 'string' ? label : '';
    copy(textToCopy);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Box component="span" sx={stylesObj.label}>
        {label}
      </Box>
      {description && (
        <Box component="span" sx={stylesObj.description}>
          {description}
        </Box>
      )}
      <IconButton aria-label="Copy" onClick={clickHandler} size="small" sx={stylesObj.button} type="button">
        <FilterNoneIcon fontSize="small" sx={stylesObj.iconSmall} />
      </IconButton>
    </Box>
  );
}
